import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
import { ROLES } from "../../../../util/roleNameConstants";

export const fetchAllProjects = async (
  setAllActiveProjects: any,
  toast: any,
  setIsDataLoading?: any
) => {
  try {
    setIsDataLoading && setIsDataLoading(true);
    const response = await axios.get(
      "tl-admin/project/all?page=-1&isActive=true"
    );
    const projectsWithTBC = response.data.result.sort((a: any, b: any) => {
      // Always put TBC first
      if (a.projectKey === "TBC") return -1;
      if (b.projectKey === "TBC") return 1;

      // Extract last 6 characters and convert to numbers
      const aKey = parseInt(a.projectKey.slice(-6), 10) || 0;
      const bKey = parseInt(b.projectKey.slice(-6), 10) || 0;

      // Compare numerically in DESCENDING order (bKey - aKey)
      return bKey - aKey;
    });
    setAllActiveProjects(projectsWithTBC);
    setIsDataLoading && setIsDataLoading(false);
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    setIsDataLoading && setIsDataLoading(false);
    showError(errorMessage, toast);
  }
};

export const fetchVehicles = async (setVehiclesList: any, toast: any) => {
  try {
    const response = await axios.get("tl-admin/vehicle/all?page=-1");
    // const filteredVehicles = response.data.result.filter(
    //   (vehicle: any) => vehicle.registration_no !== "No Vehicle"
    // );
    response.data.result.sort((a: any, b: any) => {
      // Always put TBC first
      if (a.registration_no === "No Vehicle") return -1;
      if (b.registration_no === "No Vehicle") return 1;

      // Extract last 6 characters and convert to numbers
      const aKey = parseInt(a.registration_no.slice(-6), 10) || 0;
      const bKey = parseInt(b.registration_no.slice(-6), 10) || 0;

      // Compare numerically in DESCENDING order (bKey - aKey)
      return bKey - aKey;
    });
    setVehiclesList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchUsersList = async (
  setUsersList: any,
  toast: any,
  setIsDataLoading?: any,
  isPermitSpaceFormAttached?: any,
  currentFormValues?: any,
  safeSetSelectedNames?: any
) => {
  try {
    setIsDataLoading && setIsDataLoading(true);
    const response = await axios.get(
      `admin/user/list?page=-1&roleName=${encodeURIComponent(ROLES.HANDS_USER)}`
    );
    setUsersList(response.data.result);
    if (isPermitSpaceFormAttached) {
      safeSetSelectedNames(
        response.data.result.filter((user: any) =>
          currentFormValues?.name?.some(
            (selectedUser: any) => selectedUser.userID === user.userID
          )
        )
      );
    }
    setIsDataLoading && setIsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDataLoading && setIsDataLoading(false);
    showError(error, toast);
  }
};

export const fetchKeyPlantsDetails = async (
  setKeyPlantsDetailsList: any,
  toast: any
) => {
  try {
    const response = await axios.get(
      `health-and-safety/key-plants-details-list?subModuleName=${encodeURIComponent(
        "Environment Surveying"
      )}`
    );
    // form=environmentSurveying
    setKeyPlantsDetailsList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchActivitiesList = async (
  setActivitiesList: any,
  toast: any,
  setIsDataLoading?: any,
  isPermitSpaceFormAttached?: any,
  currentFormValues?: any,
  safeSetSelectedPurposeOfEntry?: any
) => {
  try {
    setIsDataLoading && setIsDataLoading(true);
    const response = await axios.get(
      `health-and-safety/activities-list?subModuleName=${encodeURIComponent(
        "Environment Surveying"
      )}`
    );
    setActivitiesList(response.data.result);
    if (isPermitSpaceFormAttached) {
      safeSetSelectedPurposeOfEntry(
        response.data.result.find(
          (item: any) => item.name === currentFormValues?.purposeOfEntry?.name
        )
      );
    }
    setIsDataLoading && setIsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDataLoading && setIsDataLoading(false);
    showError(error, toast);
  }
};

export const fetchClosestAandE = async (
  setClosestAandEList: any,
  toast: any
) => {
  try {
    const response = await axios.get("health-and-safety/closest-ae-list");
    setClosestAandEList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchEmergencyContacts = async (
  setEmergencyContactsList: any,
  toast: any
) => {
  try {
    const response = await axios.get(
      "health-and-safety/emergency-contact-list"
    );
    setEmergencyContactsList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchActionsList = async (setActionsList: any, toast: any) => {
  try {
    const response = await axios.get(
      `health-and-safety/action-taken-list?subModuleName=${encodeURIComponent(
        "Environment Surveying"
      )}`
    );
    setActionsList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchAllEnvironmentalSurveyingChecklistForm = async (
  setEnvironmentalSurveyingChecklist: any,
  setEnvironmentalSurveyingChecklistLoading: any,
  filters: any,
  toast: any
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }
    setEnvironmentalSurveyingChecklistLoading(true);
    const response = await axios.get(
      "health-and-safety/get-daily-risk-assessment-survey-form-list",
      {
        params,
      }
    );
    setEnvironmentalSurveyingChecklist(response.data.result);
    setEnvironmentalSurveyingChecklistLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setEnvironmentalSurveyingChecklistLoading(false);
    showError(error, toast);
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/daily-risk-assessment-survey-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/health-and-safety/environment-surveying");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};
